import { useEffect } from "react";

import { IntlProvider } from "react-intl-next";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

import { useLocale } from "@/libraries/web-framework/src/localization/use-locale";

import { ANALYTICS_PREFIX } from "../../../common/constants";
import { PageInviteProps } from "../../../common/types";
import { LeftHandSideWrapper } from "../../../common/ui/left-hand-side-wrapper/left-hand-side-wrapper";
import { RightHandSideWrapper } from "../../../common/ui/right-hand-side-wrapper/right-hand-side-wrapper";
import { useWizardConfiguration } from "../../../controllers";

import { LeftHandSidePageInvite } from "./left-hand-side/left-hand-side";
import { RightHandSidePageInvite } from "./right-hand-side/right-hand-side";

export const JFind1663PageInvite = ({
    onClickNext,
    projectName,
    columnNames
}: PageInviteProps) => {
    const locale = useLocale();
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const {
        teamType,
        projectDetails: { template }
    } = useWizardConfiguration();

    useEffect(() => {
        createAnalyticsEvent({
            action: "viewed",
            eventType: "screen",
            name: `${ANALYTICS_PREFIX}InviteStep`,
            attributes: {
                teamType,
                template
            }
        }).fire();
    }, [createAnalyticsEvent, teamType, template]);

    return (
        <IntlProvider locale={locale}>
            <LeftHandSideWrapper>
                <LeftHandSidePageInvite onClickNext={onClickNext} />
            </LeftHandSideWrapper>
            <RightHandSideWrapper>
                <RightHandSidePageInvite
                    projectName={projectName}
                    columnNames={columnNames}
                />
            </RightHandSideWrapper>
        </IntlProvider>
    );
};
